'use client';

import { c as _c } from "react/compiler-runtime";
import './chip-group.scss';
import React, { useEffect, useState } from 'react';
import { trackClick } from '@sola/tracking/components/datalayer.tsx';
import { Chip } from '../../atoms/chip/chip.tsx';
import { cn } from '../../utils/helpers.ts';
export const handleChipClick = (chip: Chip, selected: Chip[]): Chip[] => {
  if (chip.isClear) {
    return [chip];
  }
  const updated = [...selected];
  const index = selected.findIndex(c => c.value === chip.value);
  if (index !== -1) {
    updated.splice(index, 1);
  } else {
    updated.push(chip);
  }
  return updated.filter(c => !c.isClear);
};
export interface ChipGroupProps {
  chips: Chip[];
  handleSelectionChange: (selected: string[]) => void;
  className?: string;
  classNameChip?: string;
  removable?: boolean;
  selectedValues?: string[];
  onRemoveChip?: (value: string) => void;
  chipSize?: 'sm' | 'md';
  isScrollable?: boolean;
}
export const ChipGroup: React.FC<ChipGroupProps> = t0 => {
  const $ = _c(37);
  const {
    chips,
    handleSelectionChange,
    className: t1,
    classNameChip,
    removable: t2,
    selectedValues,
    onRemoveChip,
    chipSize: t3,
    isScrollable: t4
  } = t0;
  const className = t1 === undefined ? "gap-comfy-sm" : t1;
  const removable = t2 === undefined ? false : t2;
  const chipSize = t3 === undefined ? "md" : t3;
  const isScrollable = t4 === undefined ? false : t4;
  let t5;
  if ($[0] !== chips) {
    t5 = chips.filter(_temp);
    $[0] = chips;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const [internalSelected, setInternalSelected] = useState(t5);
  let t6;
  if ($[2] !== chips || $[3] !== internalSelected || $[4] !== selectedValues) {
    t6 = selectedValues ? chips.filter(chip => selectedValues.includes(chip.value)) : internalSelected;
    $[2] = chips;
    $[3] = internalSelected;
    $[4] = selectedValues;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const selectedChips = t6;
  let t7;
  let t8;
  if ($[6] !== handleSelectionChange || $[7] !== internalSelected || $[8] !== selectedValues) {
    t7 = () => {
      if (!selectedValues) {
        handleSelectionChange(internalSelected.map(_temp2));
      }
    };
    t8 = [internalSelected, selectedValues, handleSelectionChange];
    $[6] = handleSelectionChange;
    $[7] = internalSelected;
    $[8] = selectedValues;
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  useEffect(t7, t8);
  let t9;
  if ($[11] !== className || $[12] !== handleSelectionChange || $[13] !== selectedChips || $[14] !== selectedValues) {
    t9 = chip_0 => {
      trackClick(chip_0.name, chip_0.value, className || "ChipGroup");
      const updated = handleChipClick(chip_0, selectedChips);
      if (selectedValues) {
        handleSelectionChange(updated.map(_temp3));
      } else {
        setInternalSelected(updated);
      }
    };
    $[11] = className;
    $[12] = handleSelectionChange;
    $[13] = selectedChips;
    $[14] = selectedValues;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const handleClick = t9;
  let t10;
  if ($[16] !== className || $[17] !== isScrollable) {
    t10 = cn("ChipGroup flex m-none p-none", {
      "ChipGroup--scrollable": isScrollable
    }, className);
    $[16] = className;
    $[17] = isScrollable;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== chipSize || $[20] !== chips || $[21] !== classNameChip || $[22] !== handleClick || $[23] !== onRemoveChip || $[24] !== removable || $[25] !== selectedChips) {
    let t12;
    if ($[27] !== chipSize || $[28] !== classNameChip || $[29] !== handleClick || $[30] !== onRemoveChip || $[31] !== removable || $[32] !== selectedChips) {
      t12 = chip_1 => {
        const isSelected = typeof chip_1.isSelected === "boolean" ? chip_1.isSelected : selectedChips.some(c_2 => c_2.value === chip_1.value);
        return <li key={chip_1.value}><Chip {...chip_1} isSelected={isSelected} onClick={() => handleClick(chip_1)} onRemove={removable ? () => onRemoveChip ? onRemoveChip(chip_1.value) : setInternalSelected(prev => prev.filter(c_3 => c_3.value !== chip_1.value)) : undefined} removable={removable} className={classNameChip} size={chipSize} /></li>;
      };
      $[27] = chipSize;
      $[28] = classNameChip;
      $[29] = handleClick;
      $[30] = onRemoveChip;
      $[31] = removable;
      $[32] = selectedChips;
      $[33] = t12;
    } else {
      t12 = $[33];
    }
    t11 = chips.map(t12);
    $[19] = chipSize;
    $[20] = chips;
    $[21] = classNameChip;
    $[22] = handleClick;
    $[23] = onRemoveChip;
    $[24] = removable;
    $[25] = selectedChips;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[34] !== t10 || $[35] !== t11) {
    t12 = <ul className={t10}>{t11}</ul>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
};
function _temp(c) {
  return c.isSelected;
}
function _temp2(c_0) {
  return c_0.value;
}
function _temp3(c_1) {
  return c_1.value;
}